import React from 'react';
import { ImageOff, Lightbulb, Newspaper } from "lucide-react";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";
import dashboard from "../../../resources/dashboard";
import EmployeeAvatar from "../../employee/avatar/employee-avatar";

interface IArticlesCardView {
    data: {
        title: string,
        description: string,
        publishedDate: string,
        url: string,
        coverImage: string,
        profileImageURL: string
    }[];
    isLoading: boolean
}

const ArticlesCardView: React.FC<IArticlesCardView> = ({data, isLoading}) => {

    const resources = dashboard.articlesCard;

    function redirectToArticle(url: string) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    return (
        <div className="dashboard-articles-card dashboard-card">
            <div className={'dashboard-card__header'}>
                <span className={'dashboard-card__icon-wrapper dashboard-articles-card__icon-wrapper'}>
                       <Lightbulb className={'dashboard-card__icon dashboard-articles-card__icon'}/>
                </span>

                <h5 className={'dashboard-card__title'}>
                    {resources.title}
                    <p className={'dashboard-card__description'}>
                        {resources.description}
                    </p>
                </h5>
            </div>
            <LoadingSkeleton loading={isLoading}>
                <div className={'dashboard-articles-card__list'}>
                    {data.length > 0 ? (data.slice(0, 4).map((item: any) => {
                        const thumbnailURL = item.coverImage?.replace('width=1000,height=420',
                            'width=160,height=160')
                        return (
                            <div
                                key={item.title}
                                className={'dashboard-articles-card__item'}
                                onClick={() => redirectToArticle(item.url)}
                            >

                                <img src={thumbnailURL} alt={'Error :('}
                                     className={'dashboard-articles-card__thumbnail'}/>

                                <div className={'dashboard-articles-card__content'}>
                                    <h6 className={'dashboard-articles-card__title'}>{item.title}</h6>
                                    {/*<p className={'dashboard-articles-card__description'}>{item.description}</p>*/}
                                    <div className={'dashboard-articles-card__meta'}>
                                        {/*<EmployeeAvatar*/}
                                        {/*    profileURL={item.profileImageURL}*/}
                                        {/*    size={20}*/}
                                        {/*    name={{firstName: item.author}}*/}
                                        {/*/>*/}
                                        <span className={'dashboard-articles-card__author-name'}>
                                    {item.author}
                                    </span>
                                        <span className={'dashboard-articles-card__date'}>
                                        {item.publishedDate}
                                     </span>
                                    </div>

                                </div>
                            </div>
                        )
                    })) : (

                        <div className={'dashboard-articles-card__empty-container'}>
                            <div className={'icon-wrapper'}>
                                <Newspaper className={'icon'}/>
                            </div>
                            <div className={'empty-container-content'}>
                                <h5 className={'title'}>{resources.emptyCardTitle}</h5>
                                <p className={'description'}>{resources.emptyCardContent}</p>
                            </div>
                        </div>
                    )
                    }
                </div>
            </LoadingSkeleton>
        </div>
    )


}

export default ArticlesCardView;
